import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography, Button, Divider } from '@material-ui/core';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import LogoBabastudio from '../../asset/Logo_Babastudio.png';
import LogoTechfor from '../../asset/Logo_Techfor.png';
import LogoSekolahpintar from '../../asset/Logo_SekolahPintar.png';

const useStyles = makeStyles((theme) => ({
    mobile:{
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        marginInline: theme.spacing(2),
        marginBottom: theme.spacing(5),
    },
    desktop: {
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
        marginInline: theme.spacing(2),
        marginBottom: theme.spacing(5),
    },
    title: {
        fontWeight: 600,
    },
    divider: {
        marginBottom: theme.spacing(2),
    },
    footer: {
        marginTop: theme.spacing(4),
    }
}));


const NewFootbar = () => {
    const classes = useStyles();

    const getDynamicImage = () => {
        if(process.env.REACT_APP_PLATFORM === "Babastudio"){
            return LogoBabastudio
        } else if (process.env.REACT_APP_PLATFORM === "SekolahPintar") {
            return LogoSekolahpintar
        } else if (process.env.REACT_APP_PLATFORM === "Techfor.id") {
            return LogoTechfor
        } else {
            return null
        }
    }

    const mobileFootbar = (
        <React.Fragment>
            <div className={classes.mobile}>
                <Grid container direction="row" spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Anda butuh bantuan?</Typography>
                        <Typography variant="subtitle2" >Hubungi CS kami</Typography>
                        <Button startIcon={<WhatsAppIcon />} style={{backgroundColor: "#25D366"}} variant="contained" href="/tanya-cs">klik disini</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Kami siap melayani anda</Typography>
                        <Typography variant="subtitle2">Senin - Jumat : 09:00 - 17:00 WIB</Typography>
                        <Typography variant="subtitle2">Sabtu - Minggu & Hari Besar <b>Libur</b></Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Jadwal Jam Belajar</Typography>
                        <Typography variant="subtitle2" >Anda bisa belajar <b>kapan saja</b> setiap hari</Typography>
                        <Typography variant="subtitle2" style={{cursor: 'pointer'}} onClick={() => window.location.assign('/syarat-dan-ketentuan')}><b>Syarat dan ketentuan</b></Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Anda memiliki pertanyaan?</Typography>
                        <Typography variant="subtitle2" >Pertanyaan yang sering diajukan</Typography>
                        <Button startIcon={<LiveHelpIcon />} style={{paddingInline: '40px'}} color="primary" variant="contained" href="/faq">FAQ</Button>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
      );

      const desktopFootbar = (
        <React.Fragment>
            <div className={classes.desktop}>
                <Grid container direction="row" justify="center" spacing={1}>
                    <Grid item>
                        <img src={getDynamicImage()} width={350} alt={process.env.REACT_APP_MAIN_LOGO}/>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Jadwal Jam Belajar</Typography>
                        <Typography variant="subtitle2" >Anda bisa belajar <b>kapan saja</b> setiap hari</Typography>
                        <Typography variant="subtitle2" style={{cursor: 'pointer'}} onClick={() => window.location.assign('/syarat-dan-ketentuan')}><b>Syarat dan ketentuan</b></Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Kami siap melayani anda</Typography>
                        <Typography variant="subtitle2">Senin - Jumat : 09:00 - 17:00 WIB</Typography>
                        <Typography variant="subtitle2">Sabtu - Minggu & Hari Besar <b>Libur</b></Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Anda membutuhkan bantuan?</Typography>
                        <Typography variant="subtitle2" >Hubungi CS kami</Typography>
                        <Button startIcon={<WhatsAppIcon />} style={{backgroundColor: "#25D366"}} variant="contained" href="/tanya-cs">Customer Service</Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="h6" gutterBottom className={classes.title}>Anda memiliki pertanyaan?</Typography>
                        <Typography variant="subtitle2" >Pertanyaan yang sering diajukan</Typography>
                        <Button startIcon={<LiveHelpIcon />} style={{paddingInline: '80px'}} color="primary" variant="contained" href="/faq">FAQ</Button>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
      );

    return (
        <React.Fragment>
            <Divider className={classes.divider}/>
            <div className={classes.footer}>
                {mobileFootbar}
                {desktopFootbar}
            </div>
            <Grid item xs={12} style={{backgroundColor: "#002157", paddingBlock: "10px"}}>
                <Typography variant="subtitle2" style={{color: "#ffffff", textAlign: "center"}}> Copyright @2020 {process.env.REACT_APP_MAIN_URL_FOOTER}, All right reserved.</Typography>
            </Grid>
        </React.Fragment>
    )
}

export default NewFootbar;